import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Conectividad/addMaquina`, method: 'POST', body: values, token: token})
}